import React, { useEffect, useState } from "react";
// import { newRole } from "../../../services/settings";
import toast from "react-hot-toast";
import Toggle from "../../../components/Toggle";
import BusinessName from "../../../components/BusinessName";

const RoleDetails = ({ handleRole }) => {
  const [rolename, setRoleName] = useState("");
  const [roledesp, setRoleDesp] = useState("");
  const maxLength = 250;

  //   const fetchRoles = async () => {
  //     try {
  //       const res = await newRole();
  //       setNewRole(res.data);
  //     } catch (error) {
  //       if (error.response) {
  //         toast.error(error.response.data.message);
  //       }
  //     }
  //   };

  const handleName = (e) => {
    setRoleName(e.target.value);
  };

  const handleRoleDesp = (e) => {
    const newValue = e.target.value;
    if (newValue.length <= maxLength) {
      setRoleDesp(newValue);
    } else {
      toast.error(
        `Maximum length for Role Description is ${maxLength} characters.`
      );
    }
  };

  const handleSubmit = () => {
    if (!rolename || !roledesp) {
      toast.error("Please enter both role name and description.");
      return;
    }
    handleRole(rolename, roledesp);
  };

  const cancelRole = () => {
    // setAddSettle(false);
    // setSettle(true);
  };

  //   useEffect(() => {
  //     fetchRoles();
  //   }, []);

  return (
    <div>
      <div className="flex w-full flex-col sm:flex-row items-start md:items-center justify-between">
        <h1 className="text-2xl font-bold text-navy-blue">
          Settings - Permission
        </h1>
        <Toggle />
      </div>

      {/* <section className="flex md:justify-end text-xl font-bold pt-4 mb-4 pr-4">
        <span className="ml-2">
          <BusinessName />
        </span>
      </section> */}

      <div className="md:w-[1200px] md:max-w-full max-w-72 h-[924px] bg-white mt-8 rounded-[10px] md:p-[3rem]">
        <div className="border border-gray-200 rounded-t-[10px] p-[1rem] pl-7 flex justify-between items-center">
          <p className="text-primary text-xl font-semibold">
            Add user permission
          </p>
          <span>
            <svg
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.5 6.75L9 11.25L13.5 6.75"
                stroke="#464255"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </div>

        <section className="flex mt-6 px-6">
          <article className="flex-[0.5] gap-6 justify-center flex-col flex ">
            <div className="flex items-center gap-6 ">
              <div className="bg-primary p-3 flex justify-center items-center text-white w-[100px] h-[23px] rounded-[10px]">
                Step 1 of 2
              </div>
              <span className="text-xl"> Role Details </span>
            </div>

            <div className="md:w-[500px] max-w-52 md:max-w-full">
              Enter a name for this role and a description of the
              responsibilities for this role to proceed. You can make changes to
              this much later.
            </div>

            <div className="flex flex-col">
              <label
                htmlFor="role-name"
                className="text-gray-600 font-semibold"
              >
                Name of role
              </label>
              <input
                type="text"
                name="role-name"
                value={rolename}
                onChange={handleName}
                placeholder="Example: Chief of staff"
                className="bg-form-background w-60 md:w-[460px] h-[50px] mt-2 px-2 rounded-md text-gray-600 focus:outline-none"
              />
            </div>

            <div className="relative flex flex-col gap-2">
              <label
                htmlFor="role-description"
                className="text-gray-600 font-semibold"
              >
                Role description
              </label>
              <textarea
                type="text"
                name="role-description"
                value={roledesp}
                onChange={handleRoleDesp}
                maxLength={maxLength}
                className="bg-form-background  w-60 md:w-[460px] h-[150px] pt-7 px-2 rounded-md text-gray-600 focus:outline-none relative border resize-none "
                placeholder="Type here..."
              />
              <div className="absolute inset-y-0 bottom-40 md:bottom-16 right-44 flex justify-end items-center pr-4">
                <span className="text-gray-400">
                  <span className="count">{roledesp.length}</span> / {maxLength}
                </span>
              </div>

              <div className="w-[425px] mt-8 flex flex-col md:flex-row justify-between">
                <button
                  onClick={cancelRole}
                  className="w-[142px] text-primary border border-primary p-2 rounded-md"
                >
                  Cancel
                </button>
                <button
                  onClick={handleSubmit}
                  className="md:w-[272px] w-[142px] mt-5 md:mt-0 bg-primary text-white p-2 rounded-md "
                >
                  Continue to permission
                </button>
              </div>
            </div>
          </article>

          <article className="flex-[0.5]"></article>
        </section>
      </div>
    </div>
  );
};

export default RoleDetails;
